var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "v-layout",
    { staticClass: "bg-warehouse" },
    [
      _c(
        "v-flex",
        {
          staticClass: "full-width",
          attrs: { "align-self-center": "", grow: "1" },
        },
        [
          _c(
            "v-card",
            {
              staticClass:
                "center-dialog align-center justify-center bg-white ph-2",
            },
            [
              _c(
                "v-card-title",
                { staticClass: "text-center" },
                [
                  _c(
                    "v-row",
                    [
                      _c("v-col", { attrs: { cols: "12" } }, [
                        _c("h3", { staticClass: "primary--text" }, [
                          _vm._v("Model Pipeline Viewer"),
                        ]),
                      ]),
                    ],
                    1
                  ),
                ],
                1
              ),
              _c(
                "v-card-text",
                { staticClass: "text-center" },
                [
                  _c(
                    "v-row",
                    [
                      _c("v-col", { attrs: { cols: "4" } }),
                      _c(
                        "v-col",
                        { attrs: { cols: "4" } },
                        [
                          _c(
                            "v-btn",
                            {
                              attrs: { color: "primary" },
                              on: {
                                click: function ($event) {
                                  return _vm.$emit("login")
                                },
                              },
                            },
                            [_vm._v("Log In")]
                          ),
                        ],
                        1
                      ),
                      _c("v-col", { attrs: { cols: "4" } }),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }